export const isRTL = (language: string): boolean => {
  return language === 'ar';
};

export const getDirection = (language: string): 'rtl' | 'ltr' => {
  return isRTL(language) ? 'rtl' : 'ltr';
};

export const applyDirection = (language: string) => {
  const direction = getDirection(language);
  document.documentElement.dir = direction;
  document.documentElement.lang = language;
};
